import './ReducedAvailabilityMessage.scss';

interface Props {
	iconColor: string;
	message: string;
}

export default function ReducedAvailabilityMessage({ iconColor, message }: Props) {
	return (
		<div className={`reducedAvailabilityMessage reducedAvailabilityMessage--${iconColor} ty-d4`}>
			<div className={'reducedAvailabilityMessage__message ty-d4'}>{message}</div>
		</div>
	);
}
